<template>
  <!-- The Modal -->
  <div
    id="editModal"
    class="modal"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
          >
            &times;
          </button>
        </div>
        <!-- Modal body -->
        <div class="">
          <!--Start-->
          <b-card-code
            title="Edit Service"
          >
            <!-- form -->
            <validation-observer ref="simpleRules">
              <b-form>
                <b-row>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name_en">Name «<span class="text-muted">English</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Name En"
                        rules="required"
                      >
                        <b-form-input
                          id="name_en"
                          v-model="updatedService.name"
                          name="name_en"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group>
                      <label for="name_ar">Name «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Name Ar"
                        rules="required"
                      >
                        <b-form-input
                          id="name_ar"
                          v-model="updatedService.nameAR"
                          class="arabic-font"
                          name="name_ar"
                          :state="errors.length > 0 ? false:null"
                          placeholder=""
                          :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label for="textarea-default">Description  «<span class="text-muted">English</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        name="Description En"
                        rules="required"
                      >
                        <template>
                          <b-form-textarea
                            id="textarea-default"
                            v-model="updatedService.description"
                            :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                            placeholder="Textarea"
                            rows="5"
                            cols="12"
                          />
                        </template>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="descriptionAR">Description  «<span class="text-muted">Arabic</span>»</label>
                      <validation-provider
                        #default="{ errors }"
                        description_ar
                        name="Description AR"
                        rules="required"
                      >
                        <b-form-textarea
                          id="descriptionAR"
                          v-model="updatedService.descriptionAR"
                          class="arabic-font"
                          :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                          placeholder=""
                          rows="5"
                          cols="12"
                          :dir="'rtl'"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="image">Image</label>
                      <validation-provider
                        #default="{ errors }"
                        name="image"
                        rules=""
                      >
                        <vue-dropzone
                          id="image"
                          ref="editServiceRef"
                          name="image"
                          :options="dropzoneOptions"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="12">
                    <b-form-group>
                      <label for="service_parent_id">Parent</label>
                      <validation-provider
                        #default="{ errors }"
                        name="service_parent_id"
                        rules=""
                      >
                        <v-select
                          v-model="selected"
                          class="parent-service"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="services"
                          :reduce="name => name.id"
                          label="name"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <!-- Modal footer -->
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="validationForm"
                  >
                    Submit
                  </button>
                </div>
              </b-form>
            </validation-observer>

            <template #code>
              {{ codeMultiple }}
            </template>
          </b-card-code>
          <!--End-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput, BFormGroup, BForm, BRow, BCol,
  BFormTextarea,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import vSelect from 'vue-select'
import vue2Dropzone from 'vue2-dropzone'
import { codeMultiple, codeBasic } from './code'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import companyService from '@/services/companyService'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCardCode,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,

    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    vSelect,
    vueDropzone: vue2Dropzone,
  },
  props: ['service', 'services'],
  data() {
    return {
      updatedService: {
        id: '',
        name: '',
        nameAR: '',
        description: '',
        descriptionAR: '',
        image: '',
        serviceParentId: '',
      },
      emailValue: '',
      PasswordValue: '',
      passwordCon: '',
      required,
      password,
      email,
      confirmed,
      codeMultiple,
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
        parallelUploads: 1,
        maxFiles: 1,

      },
      codeBasic,
      selected: null,
    }
  },
  mounted() {
    this.$watch(() => this.service, val => {
      /* Init Updated Object (Which will be sent To API) */
      /* Init Drop Zone */
      this.$refs.editServiceRef.removeAllFiles()
      this.$refs.editServiceRef.manuallyAddFile(val.image.file, val.image.url)

      /* Init Select2 */
      this.updatedService = {
        id: val.id,
        name: val.name,
        nameAR: val.nameAR,
        description: val.description,
        descriptionAR: val.descriptionAR,
        image: '',
        serviceParentId: '',
      }
      this.selected = val.parent?.id ?? null
    })
  },
  created() {
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate()
        .then(success => {
          if (success) {
            /* Init Image & Parent Service Updated Object (Which will be sent To API) */
            this.updatedService.image = this.$refs.editServiceRef.getAcceptedFiles()[0] ?? ''
            this.updatedService.serviceParentId = this.selected ?? ''
            companyService.put(this.updatedService).then(response => {
              this.$emit('refresh', 'true')
              this.$refs.editServiceRef.removeAllFiles()

              $('#editModal').modal('hide')
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Service Is Updated Successfully !',
                  },
                })
              }
              this.loading = false
            })
          }
        }).catch(function (error) {
          $('#editModal')
            .modal('hide')
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              icon: 'CheckIcon',
              variant: 'Error',
              text: 'Error !',
            },
          })
          return Promise.reject(error)
        })
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
label{
  font-weight: bold;
}
</style>
